import React from "react";
import Select from "react-select";

const MultiSelect = ({
  name,
  placeholder,
  data,
  disabled,
  defaultValueArr,
  multiSelectVal,
  setMultiSelectVal,
  locationName,
  multi,
}) => {

  let npRecord = [];
  // const options = multi
  // ? [{ label: "Select All", value: "all" }, ...data]
  // : data;
  return (
    <div className="location-wrapper-invoice">
     {locationName ?<Select
          value={null}
          name={name}
          closeMenuOnSelect={false}
          defaultValue={defaultValueArr}
          isMulti
          placeholder={placeholder}
          options={data && data[0].value !== "" ? data : npRecord}
          // options={options}
          className="basic-multi-select"
          classNamePrefix="select"
          isSearchable={false}
          isDisabled={disabled}
          noOptionsMessage={() => "No records"}
          isClearable={true}
          onChange={(data, index) => {
            if (data !== null) {
              setMultiSelectVal(data);
              // multi &&
              // data?.length &&
              // data.find((option) => option.value === "all")
              //   ? setMultiSelectVal(options.slice(1))
              //   : !multi
              //   ? setMultiSelectVal((data && data.value) || null)
              //   : setMultiSelectVal(data);   
            } else {
              // Handle the case when data is null (value is cleared)
              setMultiSelectVal([]); // or setMultiSelectVal(null) depending on your use case
            }
          }}
        />:
        <Select
          // value={locationName?null :}
          name={name}
          closeMenuOnSelect={false}
          defaultValue={defaultValueArr}
          isMulti
          placeholder={placeholder}
          options={data && data[0].value !== "" ? data : npRecord}
          // options={options}
          className="basic-multi-select"
          classNamePrefix="select"
          isSearchable={false}
          isDisabled={disabled}
          noOptionsMessage={() => "No records"}
          isClearable={true}
          onChange={(data, index) => {
            if (data !== null) {
              setMultiSelectVal(data);
              // multi &&
              // data?.length &&
              // data.find((option) => option.value === "all")
              //   ? setMultiSelectVal(options.slice(1))
              //   : !multi
              //   ? setMultiSelectVal((data && data.value) || null)
              //   : setMultiSelectVal(data);   
            }else {
              // Handle the case when data is null (value is cleared)
              setMultiSelectVal([]); // or setMultiSelectVal(null) depending on your use case
            }
          }}
        />}
    </div>
  );
};
export default MultiSelect;
